import {Injectable, signal} from '@angular/core';
import {FormControl, FormGroup} from '@angular/forms';
import {BehaviorSubject} from 'rxjs';
import {KtCogsFilterForm, KtCogsFilterModel} from '../models/kt-filter.model';

@Injectable({providedIn: 'root'})
export class KtCogsFilterService {
  public readonly filtersValue = signal<KtCogsFilterModel>(this.buildDefaultFilters());
  public readonly toggleModal = signal<boolean>(false);

  private readonly filters$ = new BehaviorSubject<KtCogsFilterModel>(this.filtersValue());

  public get form(): KtCogsFilterForm {
    return new FormGroup({
      TripReference: new FormControl<string | null>(null),
      VendorName: new FormControl<string | null>(null),
      ProductTypeName: new FormControl<string | null>(null),
    });
  }

  public getFilters() {
    return this.filters$.asObservable();
  }

  public setFilters(value: KtCogsFilterModel): void {
    this.filtersValue.set(value);
    this.filters$.next(value);
  }

  private buildDefaultFilters(): KtCogsFilterModel {
    return {
      TripReference: null,
      VendorName: null,
      ProductTypeName: null,
      ReloadGrid: false,
    };
  }
}
